export function formIdparser(id) {
	const parsed = id.replaceAll('_', '.');
	const split = parsed.split('.').filter(Boolean);
	if (split.length !== 5) {
		return null;
	}
	const parsedString = `${split[0]}.${split[1]}.${split[2]}[${split[3]}].${split[4]}`;
	return parsedString;
}
